<template>
  <el-dialog title="问题反馈" :visible.sync="isShowDialog" width="30%">
    <el-form :model="formItem" ref="feedbackForm" :rules="rules">
      <el-form-item label="反馈类型" :label-width="formLabelWidth" prop="tid">
        <el-select v-model="formItem.tid" placeholder="请选择反馈类型">
          <el-option label="游戏崩溃或闪退" value="1"></el-option>
          <el-option label="游戏经常掉线" value="2"></el-option>
          <el-option label="支付问题" value="3"></el-option>
          <el-option label="BUG提交" value="4"></el-option>
          <el-option label="游戏建议" value="5"></el-option>
          <el-option label="问题咨询" value="6"></el-option>
          <el-option label="数据异常" value="7"></el-option>
          <el-option label="投诉" value="8"></el-option>
          <el-option label="举报" value="9"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话" :label-width="formLabelWidth" prop="phone">
        <el-input v-model="formItem.phone" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="反馈内容"
        :label-width="formLabelWidth"
        prop="content"
      >
        <el-input type="textarea" v-model="formItem.content"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset()">取 消</el-button>
      <el-button type="primary" @click="handleSubmit()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getUserInfo, userFeedback } from '@/api/user'

export default {
  data () {
    return {
      isShowDialog: false,
      formItem: {
        tid: '',
        phone: '',
        content: ''
      },
      rules: {
        tid: [
          { required: true, message: '请选择反馈类型', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的联系电话', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入反馈内容', trigger: 'blur' },
          { min: 10, max: 100, message: '反馈内容长度在20 - 100个字符', trigger: 'blur' }
        ]
      },
      formLabelWidth: '80px'
    }
  },
  methods: {
    handleReset () {
      this.$refs.feedbackForm.resetFields()
      this.isShowDialog = false
    },
    handleSubmit () {
      getUserInfo().then(response => {
        if (response.data.code === 0) {
          var userInfo = response.data.data
          this.$refs.feedbackForm.validate(checkRes => {
            if (checkRes) {
              var requestParams = {
                tid: this.formItem.tid,
                msg: this.formItem.content,
                contact: this.formItem.phone,
                chrid: userInfo.chrid,
                gameid: this.$config.gameId,
                chann: this.$config.channel
              }
              userFeedback(requestParams).then(response => {
                const res = response.data
                if (res.code === 1) {
                  this.$message.success('提交成功')
                  this.isShowDialog = false
                  this.$refs.feedbackForm.resetFields()
                } else {
                  this.$message.warning(res.msg)
                }
              })
            } else {
              this.$message.warning('请认真填写反馈内容')
            }
          })
        } else {
          this.$message.error({
            message: '请先登录',
            duration: 2000,
            customClass: 'zZindex'
          })
          this.isShowDialog = false
          this.$store.commit('showLoginBox', true)
          this.$store.commit('showBlackOver', 'block')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/service_center/children/FeedbackForm.vue